// src/components/TopBanner.jsx
import React from "react";

const TopBanner = () => (
  <header
    className="app-header"
    style={{
      backgroundImage: `url(${process.env.PUBLIC_URL}/Header4.png)`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "contain",
    }}
  />
);

export default TopBanner;
